import api from './api';

export interface InventoryItem {
  id: number;
  name: string;
  code: string;
  unit: string;
  min_stock_level: number;
  total_quantity: number;
  lot_count: number;
  current_stock?: number; // For low stock API
}

export interface InventoryLot {
  id: number;
  medicine_id: number;
  lot_number: string;
  expiry_date: string;
  quantity: number;
  cost_price: number;
  supplier_id: number;
  import_date: string;
  medicine_name: string;
  medicine_code: string;
  unit: string;
  supplier_name: string;
}

export interface Medicine {
  id: number;
  name: string;
  code: string;
  active_ingredient: string;
  dosage_form: string;
  strength: string;
  unit: string;
  manufacturer: string;
  min_stock_level: number;
  max_stock_level: number;
  current_stock: number;
  price: number;
  is_active: boolean;
}

export interface InventoryHistory {
  type: 'IN' | 'OUT';
  voucher_number: string;
  created_at: string;
  quantity: number;
  lot_number: string;
  expiry_date: string;
  supplier_name: string;
  created_by: string;
  status: 'pending' | 'completed' | 'cancelled';
}

export const inventoryService = {
  // Lấy danh sách tồn kho tất cả thuốc
  getInventory: async (): Promise<InventoryItem[]> => {
    const response = await api.get('/api/inventory');
    return response.data.data;
  },

  // Lấy chi tiết tồn kho của một thuốc
  getInventoryDetails: async (medicineId: number): Promise<{ medicine: Medicine; lots: InventoryLot[] }> => {
    const response = await api.get(`/api/inventory/medicine/${medicineId}`);
    return response.data.data;
  },

  // Lấy danh sách thuốc tồn kho thấp
  getLowStock: async (): Promise<InventoryItem[]> => {
    const response = await api.get('/api/inventory/low-stock');
    return response.data.data;
  },

  // Lấy danh sách thuốc sắp hết hạn
  getExpiring: async (days: number = 90): Promise<InventoryLot[]> => {
    const response = await api.get(`/api/inventory/expiring?days=${days}`);
    return response.data.data;
  },

  // Lấy lịch sử tồn kho của một thuốc
  getInventoryHistory: async (medicineId: number, limit: number = 50): Promise<InventoryHistory[]> => {
    const response = await api.get(`/api/inventory/history/${medicineId}?limit=${limit}`);
    return response.data.data;
  }
}; 